import { Anchor, Flex, Text, UnstyledButton } from "@mantine/core";

import styles from "./WidgetContainer.module.css";

interface StatsHeaderProps {
    opened: boolean;
    onClick: () => void;
}

export function StatsHeader({ opened, onClick }: StatsHeaderProps) {
    return (
        <Flex data-testid="stats-header" className={styles.widgetMain} direction="column" fz="xs" onClick={onClick}>
            <Flex className={styles.inner}>
                <Text fw={700} lh="md">
                    My stats
                </Text>
                <UnstyledButton variant="outline">
                    <Flex align="center">
                        <Anchor c="primary.1" size="xxs" underline="always">
                            Show {opened ? "less" : "more"}
                        </Anchor>
                    </Flex>
                </UnstyledButton>
            </Flex>
        </Flex>
    );
}
